import { render, staticRenderFns } from "./BpExpensesNumberDisplayer.vue?vue&type=template&id=7b4a5a4a"
import script from "./BpExpensesNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./BpExpensesNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports